import { render, staticRenderFns } from "./GroupTasks.vue?vue&type=template&id=0a3e15be"
import script from "./GroupTasks.vue?vue&type=script&lang=js"
export * from "./GroupTasks.vue?vue&type=script&lang=js"
import style0 from "./GroupTasks.vue?vue&type=style&index=0&id=0a3e15be&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports